import { useEffect } from "react";
import styles from "./ProductList.css";
import ResultsSpinner from "./ResultsSpinner";

const ProductListSkeleton = () => {
  const tiles = [...Array(8).keys()];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className={styles.skeletonContainer}>
      <ResultsSpinner />
      <div className={styles.skeletonHeader} id="skeletonHeader" />
      <div className={styles.skeletonFilters} id="skeletonFilters" />
      <ul className={styles.skeletonTiles}>
        {tiles.map((tile, index) => (
          <li
            key={index}
            className={styles.skeletonProductTile}
            id="skeletonProductTile"
          >
            <div className={styles.skeletonProductImage} />
            <div className={styles.skeletonTextOne} />
            <div className={styles.skeletonTextTwo} />
            <div className={styles.skeletonTextThree} />
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ProductListSkeleton;
